// Search
export const INIT_SEARCH = 'initSearch';
export const SET_TAB_TYPE = 'setTabType';
export const SET_SEARCH_TEXT = 'setSearchText';
export const SET_SEARCH_LIKE = 'setSearchListLike';
export const SEARCH_DISCOVER_LOADING = 'SearchDiscoverLoading';
export const SEARCH_DISCOVER_SUCCESS = 'SearchDiscoverSuccess';
export const SEARCH_DISCOVER_FAIL = 'SearchDiscoverFail';
export const SEARCH_NEXT_DISCOVER_SUCCESS = 'SearchNextDiscoverSuccess';
export const SEARCH_NEXT_DISCOVER_FAIL = 'SearchNextDiscoverFail';
